export default {
  email: "Email",
  submit: "Invite",
  invalidEmail: "Invalid email, try again.",
};



// WEBPACK FOOTER //
// ./src/components/forms/collaborator-form/CollaboratorForm.messages.js